module.exports = __webpack_public_path__ + "static/media/monis.8d30a9a6.png";